import React, { useEffect } from 'react';
import Opportunities from '../components/Opportunities';

const OpportunitiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Join DigitalGigs | Current Opportunities';
  }, []);

  return (
    <main className="bg-white pt-20">
      <Opportunities />
    </main>
  );
};

export default OpportunitiesPage;
